"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeAxios = void 0;

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _axiosFetchBridge = require("@insided/shared/services/axios-bridge/axios-fetch-bridge");

// eslint-disable-next-line no-restricted-imports
var initializeAxios = function initializeAxios() {
  Object.assign(_axiosFetchBridge.fetchDefaults.headers, {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': (0, _csrfToken.csrfToken)()
  });

  _axiosFetchBridge.requestInterceptors.push(function (config) {
    // Resolve request URLs: community base, or SJ widget-proxy base in a Skilljar embed.
    if (config.url && !config.baseURL) {
      var _resolveUrl;

      config.url = (_resolveUrl = (0, _absoluteUrlRuntime.resolveUrl)(config.url, _absoluteUrlRuntime.UrlSourceType.Api)) !== null && _resolveUrl !== void 0 ? _resolveUrl : config.url;
    }

    return config;
  });
};

exports.initializeAxios = initializeAxios;